import { GameEvent } from '../types/game';

export const gameEvents: GameEvent[] = [
  // Money Events
  {
    id: 'birthday-money',
    title: 'Birthday Gift',
    description: 'You received money from family for your birthday!',
    type: 'money',
    probability: 0.3,
    minAge: 18,
    maxAge: 30,
    effects: { wealth: 500 },
    isInteractive: false,
  },
  {
    id: 'work-bonus',
    title: 'Work Bonus',
    description: 'Your employer gave you a performance bonus!',
    type: 'money',
    probability: 0.2,
    minAge: 22,
    requirements: { career: 50 },
    effects: { wealth: 2000, happiness: 10 },
    isInteractive: false,
  },
  {
    id: 'lottery-win-small',
    title: 'Small Lottery Win',
    description: 'You won a small amount in the lottery!',
    type: 'money',
    probability: 0.08,
    effects: { wealth: 5000, happiness: 20 },
    isInteractive: false,
  },
  {
    id: 'lottery-win-big',
    title: 'MEGA LOTTERY WIN!',
    description: '🎉 JACKPOT! You won the lottery! This changes everything! 🎉',
    type: 'money',
    probability: 0.001,
    effects: { wealth: 500000, happiness: 50, health: 10 },
    isInteractive: false,
  },
  {
    id: 'inheritance',
    title: 'Unexpected Inheritance',
    description: 'A distant relative left you a substantial inheritance!',
    type: 'money',
    probability: 0.05,
    effects: { wealth: 100000, happiness: 20 },
    isInteractive: false,
  },
  {
    id: 'job-promotion',
    title: 'Major Promotion',
    description: 'You received a significant promotion at work!',
    type: 'career',
    probability: 0.1,
    effects: { career: 25, wealth: 20, happiness: 15 },
    isInteractive: false,
  },
  {
    id: 'health-miracle',
    title: 'Health Miracle',
    description: 'A medical breakthrough cured your health issues!',
    type: 'health',
    probability: 0.02,
    effects: { health: 30, happiness: 25 },
    isInteractive: false,
  },
  {
    id: 'romance',
    title: 'True Love Found',
    description: 'You met the love of your life!',
    type: 'social',
    probability: 0.08,
    effects: { relationships: 30, happiness: 25, health: 10 },
    isInteractive: false,
  },
  {
    id: 'business-success',
    title: 'Business Success',
    description: 'Your business venture became incredibly successful!',
    type: 'money',
    probability: 0.03,
    effects: { wealth: 200000, career: 30, happiness: 20 },
    isInteractive: false,
  },
  {
    id: 'family-reunion',
    title: 'Family Reunion',
    description: 'A wonderful family reunion brought everyone closer!',
    type: 'social',
    probability: 0.06,
    effects: { relationships: 20, happiness: 15 },
    isInteractive: false,
  },
  {
    id: 'creative-breakthrough',
    title: 'Creative Breakthrough',
    description: 'You had a major creative breakthrough in your field!',
    type: 'career',
    probability: 0.04,
    effects: { career: 20, happiness: 20, wealth: 15 },
    isInteractive: false,
  },
  {
    id: 'stray-cat',
    title: 'Stray Cat Found',
    description: 'A friendly stray cat has been following you around. It seems to want a home.',
    type: 'social',
    probability: 0.15,
    isInteractive: true,
    icon: '🐱',
    choices: [
      {
        id: 'adopt-cat',
        title: 'Adopt the Cat',
        description: 'Take the cat home and give it a loving family',
        effects: { happiness: 15, relationships: 10 },
        cost: 50, // Monthly pet expenses
  },
      {
        id: 'decline-cat',
        title: 'Leave the Cat',
        description: 'Continue on your way without the cat',
        effects: { happiness: -5 },
  },
    ],
  },
  {
    id: 'job-offer-unexpected',
    title: 'Unexpected Job Offer',
    description: 'A company you never applied to has offered you a job with better pay!',
    type: 'career',
    probability: 0.08,
    isInteractive: true,
    icon: '💼',
    choices: [
      {
        id: 'accept-job-offer',
        title: 'Accept the Offer',
        description: 'Take the new job with better pay',
        effects: { career: 20, wealth: 25, happiness: 10 },
  },
      {
        id: 'negotiate-job-offer',
        title: 'Negotiate Terms',
        description: 'Try to get even better terms',
        effects: { career: 15, wealth: 30, happiness: 5 },
  },
      {
        id: 'decline-job-offer',
        title: 'Decline the Offer',
        description: 'Stay in your current position',
        effects: { career: 5, happiness: -5 },
  },
    ],
  },
  {
    id: 'investment-opportunity',
    title: 'Investment Opportunity',
    description: 'A friend has a "sure thing" investment opportunity. They need $5,000 to get started.',
    type: 'money',
    probability: 0.12,
    isInteractive: true,
    icon: '💎',
    choices: [
      {
        id: 'invest-5000',
        title: 'Invest $5,000',
        description: 'Trust your friend and invest the money',
        effects: { wealth: 30, happiness: 10, relationships: 15 },
        cost: 5000,
  },
      {
        id: 'invest-1000',
        title: 'Invest $1,000',
        description: 'Invest a smaller amount to be safe',
        effects: { wealth: 10, happiness: 5, relationships: 10 },
        cost: 1000,
  },
      {
        id: 'decline-investment',
        title: 'Decline Investment',
        description: 'Politely decline the opportunity',
        effects: { wealth: 5, relationships: -5 },
  },
    ],
  },
  {
    id: 'health-crisis',
    title: 'Health Crisis',
    description: 'You\'ve been feeling unwell and need to see a doctor. The treatment will be expensive.',
    type: 'health',
    probability: 0.06,
    isInteractive: true,
    icon: '🏥',
    choices: [
      {
        id: 'expensive-treatment',
        title: 'Get Best Treatment',
        description: 'Pay for the most expensive but effective treatment',
        effects: { health: 25, happiness: 10 },
        cost: 10000,
  },
      {
        id: 'basic-treatment',
        title: 'Get Basic Treatment',
        description: 'Choose a more affordable treatment option',
        effects: { health: 15, happiness: 5 },
        cost: 3000,
  },
      {
        id: 'ignore-health',
        title: 'Ignore the Problem',
        description: 'Hope it goes away on its own',
        effects: { health: -20, happiness: -15 },
  },
    ],
  },
  {
    id: 'family-emergency',
    title: 'Family Emergency',
    description: 'A family member needs financial help urgently. They\'re asking for $2,000.',
    type: 'social',
    probability: 0.10,
    isInteractive: true,
    icon: '👨‍👩‍👧‍👦',
    choices: [
      {
        id: 'help-family',
        title: 'Help Family Member',
        description: 'Give them the money they need',
        effects: { relationships: 25, happiness: 15, wealth: -10 },
        cost: 2000,
  },
      {
        id: 'partial-help',
        title: 'Give Partial Help',
        description: 'Give them half the amount they asked for',
        effects: { relationships: 15, happiness: 10, wealth: -5 },
        cost: 1000,
  },
      {
        id: 'decline-family',
        title: 'Cannot Help',
        description: 'Explain you cannot afford to help right now',
        effects: { relationships: -10, happiness: -10 },
  },
    ],
  },
  {
    id: 'crypto-boom',
    title: 'Crypto Investment Boom',
    description: 'Your cryptocurrency investments went through the roof!',
    type: 'money',
    probability: 0.02,
    requirements: { wealth: 20000 },
    effects: { wealth: 100000, happiness: 30 },
    isInteractive: false,
  },
  {
    id: 'inheritance',
    title: 'Unexpected Inheritance',
    description: 'A distant relative left you a substantial inheritance!',
    type: 'money',
    probability: 0.01,
    effects: { wealth: 75000, happiness: 25 },
    isInteractive: false,
  },
  {
    id: 'business-success',
    title: 'Business Venture Success',
    description: 'Your side business became incredibly successful!',
    type: 'money',
    probability: 0.03,
    requirements: { career: 70 },
    effects: { wealth: 25000, happiness: 35, career: 10 },
    isInteractive: false,
  },
  {
    id: 'investment-gain',
    title: 'Investment Success',
    description: 'Your investments paid off!',
    type: 'money',
    probability: 0.15,
    requirements: { wealth: 10000 },
    effects: { wealth: 5000, happiness: 10 },
    isInteractive: false,
  },
  {
    id: 'side-hustle',
    title: 'Side Hustle Success',
    description: 'Your side project generated some income!',
    type: 'money',
    probability: 0.25,
    requirements: { career: 30 },
    effects: { wealth: 800, happiness: 5 },
    isInteractive: false,
  },

  // Health Events
  {
    id: 'flu-season',
    title: 'Flu Season',
    description: 'You caught the flu and need to rest.',
    type: 'health',
    probability: 0.2,
    effects: { health: -10, wealth: -200 },
    isInteractive: false,
  },
  {
    id: 'gym-motivation',
    title: 'Gym Motivation',
    description: 'You feel motivated to start working out!',
    type: 'health',
    probability: 0.3,
    requirements: { health: 40 },
    effects: { health: 5, happiness: 5 },
    isInteractive: false,
  },
  {
    id: 'stress-relief',
    title: 'Stress Relief',
    description: 'You found a great way to manage stress.',
    type: 'health',
    probability: 0.25,
    effects: { health: 3, happiness: 8 },
    isInteractive: false,
  },

  // Social Events
  {
    id: 'new-friend',
    title: 'New Friend',
    description: 'You made a new friend at a social event!',
    type: 'social',
    probability: 0.3,
    requirements: { relationships: 30 },
    effects: { relationships: 10, happiness: 5 },
    isInteractive: false,
  },
  {
    id: 'family-gathering',
    title: 'Family Gathering',
    description: 'A family gathering strengthened your relationships.',
    type: 'social',
    probability: 0.4,
    effects: { relationships: 5, happiness: 8 },
    isInteractive: false,
  },
  {
    id: 'romantic-interest',
    title: 'Romantic Interest',
    description: 'Someone special has shown interest in you!',
    type: 'social',
    probability: 0.2,
    requirements: { relationships: 40 },
    effects: { relationships: 15, happiness: 12 },
    isInteractive: false,
  },

  // Career Events
  {
    id: 'promotion-opportunity',
    title: 'Promotion Opportunity',
    description: 'Your boss mentioned a potential promotion!',
    type: 'career',
    probability: 0.15,
    requirements: { career: 60 },
    effects: { career: 10, happiness: 8 },
    isInteractive: false,
  },
  {
    id: 'skill-development',
    title: 'Skill Development',
    description: 'You learned a new skill that could help your career.',
    type: 'career',
    probability: 0.3,
    requirements: { education: 40 },
    effects: { career: 5, education: 3 },
    isInteractive: false,
  },
  {
    id: 'networking-event',
    title: 'Networking Event',
    description: 'You attended a professional networking event.',
    type: 'career',
    probability: 0.25,
    requirements: { relationships: 50 },
    effects: { career: 8, relationships: 5 },
    isInteractive: false,
  },

  // Random Events
  {
    id: 'good-luck',
    title: 'Good Luck',
    description: 'Everything seems to be going your way today!',
    type: 'random',
    probability: 0.1,
    effects: { happiness: 10, health: 3 },
    isInteractive: false,
  },
  {
    id: 'bad-luck',
    title: 'Bad Luck',
    description: 'A series of unfortunate events occurred.',
    type: 'random',
    probability: 0.1,
    effects: { happiness: -5, wealth: -300 },
    isInteractive: false,
  },
  {
    id: 'inspiration',
    title: 'Inspiration',
    description: 'You feel inspired and motivated!',
    type: 'random',
    probability: 0.15,
    effects: { happiness: 8, education: 5 },
    isInteractive: false,
  },

  // New Events - Childhood & Teenage Years
  {
    id: 'first-day-school',
    title: 'First Day of School',
    description: 'You started school! A new chapter begins.',
    type: 'social',
    probability: 1.0,
    minAge: 6,
    maxAge: 6,
    effects: { education: 10, happiness: 5 },
    isInteractive: false,
  },
  {
    id: 'childhood-friend',
    title: 'Childhood Friend',
    description: 'You made a best friend at school!',
    type: 'social',
    probability: 0.8,
    minAge: 6,
    maxAge: 12,
    effects: { relationships: 15, happiness: 10 },
    isInteractive: false,
  },
  {
    id: 'puberty-changes',
    title: 'Puberty Begins',
    description: 'Your body is changing as you enter adolescence.',
    type: 'health',
    probability: 1.0,
    minAge: 12,
    maxAge: 14,
    effects: { health: 5, happiness: -5 },
    isInteractive: false,
  },
  {
    id: 'teenage-rebellion',
    title: 'Teenage Rebellion',
    description: 'You\'re going through a rebellious phase.',
    type: 'social',
    probability: 0.6,
    minAge: 14,
    maxAge: 17,
    effects: { relationships: -10, happiness: 5 },
    isInteractive: false,
  },
  {
    id: 'first-crush',
    title: 'First Crush',
    description: 'You have your first romantic crush!',
    type: 'social',
    probability: 0.7,
    minAge: 13,
    maxAge: 17,
    effects: { relationships: 10, happiness: 15 },
    isInteractive: false,
  },

  // Young Adult Events (18-30)
  {
    id: 'college-party',
    title: 'College Party',
    description: 'You attended an epic college party!',
    type: 'social',
    probability: 0.4,
    minAge: 18,
    maxAge: 25,
    effects: { relationships: 8, happiness: 12, health: -2 },
    isInteractive: false,
  },
  {
    id: 'internship-offer',
    title: 'Internship Opportunity',
    description: 'You got offered a great internship!',
    type: 'career',
    probability: 0.3,
    minAge: 20,
    maxAge: 25,
    requirements: { education: 30 },
    effects: { career: 15, wealth: 1000 },
    isInteractive: false,
  },
  {
    id: 'study-abroad',
    title: 'Study Abroad',
    description: 'You decided to study abroad for a semester!',
    type: 'social',
    probability: 0.2,
    minAge: 20,
    maxAge: 25,
    requirements: { education: 40 },
    effects: { education: 20, relationships: 10, happiness: 15, wealth: -5000 },
    isInteractive: false,
  },
  {
    id: 'first-apartment',
    title: 'First Apartment',
    description: 'You moved into your first apartment!',
    type: 'social',
    probability: 0.5,
    minAge: 20,
    maxAge: 25,
    effects: { happiness: 10, wealth: -2000 },
    isInteractive: false,
  },
  {
    id: 'meet-soulmate',
    title: 'Meet Your Soulmate',
    description: 'You met someone who could be the one!',
    type: 'social',
    probability: 0.3,
    minAge: 22,
    maxAge: 30,
    effects: { relationships: 25, happiness: 20 },
    isInteractive: true,
    choices: [
      {
        id: 'ask-out',
        title: 'Ask them out',
        description: 'Take a chance on love',
        effects: { relationships: 30, happiness: 25 },
        cost: 500,
      },
      {
        id: 'stay-friends',
        title: 'Stay friends for now',
        description: 'Build the friendship first',
        effects: { relationships: 15, happiness: 10 },
        cost: 0,
      },
    ],
  },
  {
    id: 'career-breakthrough',
    title: 'Career Breakthrough',
    description: 'You had a major breakthrough at work!',
    type: 'career',
    probability: 0.25,
    minAge: 25,
    maxAge: 35,
    requirements: { career: 60 },
    effects: { career: 20, wealth: 5000, happiness: 15 },
    isInteractive: false,
  },
  {
    id: 'quarter-life-crisis',
    title: 'Quarter-Life Crisis',
    description: 'You\'re questioning your life choices at 25.',
    type: 'random',
    probability: 0.4,
    minAge: 25,
    maxAge: 27,
    effects: { happiness: -10, career: -5 },
    isInteractive: false,
  },

  // Middle Age Events (30-50)
  {
    id: 'wedding-invitation',
    title: 'Wedding Invitation',
    description: 'You received a wedding invitation from a close friend.',
    type: 'social',
    probability: 0.6,
    minAge: 28,
    maxAge: 40,
    effects: { relationships: 5, wealth: -1000 },
    isInteractive: false,
  },
  {
    id: 'pregnancy-announcement',
    title: 'Pregnancy Announcement',
    description: 'You or your partner are expecting a baby!',
    type: 'social',
    probability: 0.3,
    minAge: 25,
    maxAge: 40,
    requirements: { relationships: 50 },
    effects: { relationships: 20, happiness: 25, wealth: -5000 },
    isInteractive: false,
  },
  {
    id: 'midlife-crisis',
    title: 'Midlife Crisis',
    description: 'You\'re questioning everything at 40.',
    type: 'random',
    probability: 0.5,
    minAge: 38,
    maxAge: 42,
    effects: { happiness: -15, career: -10 },
    isInteractive: false,
  },
  {
    id: 'parent-teacher-conference',
    title: 'Parent-Teacher Conference',
    description: 'You attended your child\'s parent-teacher conference.',
    type: 'social',
    probability: 0.4,
    minAge: 30,
    maxAge: 50,
    requirements: { relationships: 60 },
    effects: { relationships: 10, happiness: 8 },
    isInteractive: false,
  },
  {
    id: 'career-burnout',
    title: 'Career Burnout',
    description: 'You\'re feeling burned out at work.',
    type: 'career',
    probability: 0.3,
    minAge: 35,
    maxAge: 45,
    requirements: { career: 70 },
    effects: { career: -10, health: -15, happiness: -20 },
    isInteractive: false,
  },
  {
    id: 'empty-nest',
    title: 'Empty Nest',
    description: 'Your children have moved out.',
    type: 'social',
    probability: 0.4,
    minAge: 45,
    maxAge: 55,
    requirements: { relationships: 70 },
    effects: { relationships: -10, happiness: -5, wealth: 10 },
    isInteractive: false,
  },

  // Senior Events (50+)
  {
    id: 'grandchild-born',
    title: 'Grandchild Born',
    description: 'You became a grandparent!',
    type: 'social',
    probability: 0.3,
    minAge: 50,
    maxAge: 70,
    requirements: { relationships: 80 },
    effects: { relationships: 25, happiness: 30 },
    isInteractive: false,
  },
  {
    id: 'retirement-party',
    title: 'Retirement Party',
    description: 'You celebrated your retirement!',
    type: 'career',
    probability: 0.6,
    minAge: 60,
    maxAge: 70,
    effects: { happiness: 20, wealth: 10000 },
    isInteractive: false,
  },
  {
    id: 'health-scare',
    title: 'Health Scare',
    description: 'You had a health scare that made you think about mortality.',
    type: 'health',
    probability: 0.4,
    minAge: 50,
    maxAge: 80,
    effects: { health: -20, happiness: -15 },
    isInteractive: false,
  },
  {
    id: 'golden-anniversary',
    title: 'Golden Anniversary',
    description: 'You celebrated your 50th wedding anniversary!',
    type: 'social',
    probability: 0.2,
    minAge: 70,
    maxAge: 80,
    requirements: { relationships: 90 },
    effects: { relationships: 30, happiness: 40, wealth: 5000 },
    isInteractive: false,
  },
  {
    id: 'technology-challenge',
    title: 'Technology Challenge',
    description: 'You\'re struggling to keep up with new technology.',
    type: 'random',
    probability: 0.5,
    minAge: 60,
    maxAge: 90,
    effects: { happiness: -5, education: -5 },
    isInteractive: false,
  },

  // Random Life Events
  {
    id: 'lost-wallet',
    title: 'Lost Wallet',
    description: 'You lost your wallet and had to cancel all your cards.',
    type: 'random',
    probability: 0.1,
    effects: { wealth: -200, happiness: -10 },
    isInteractive: false,
  },
  {
    id: 'found-money',
    title: 'Found Money',
    description: 'You found some money on the street!',
    type: 'money',
    probability: 0.15,
    effects: { wealth: 50, happiness: 5 },
    isInteractive: false,
  },
  {
    id: 'car-accident',
    title: 'Minor Car Accident',
    description: 'You were in a minor car accident.',
    type: 'random',
    probability: 0.2,
    minAge: 18,
    effects: { wealth: -2000, health: -5, happiness: -10 },
    isInteractive: false,
  },
  {
    id: 'job-interview',
    title: 'Job Interview',
    description: 'You have a job interview for a better position.',
    type: 'career',
    probability: 0.3,
    minAge: 22,
    effects: { career: 10, happiness: 5 },
    isInteractive: false,
  },
  {
    id: 'reunion',
    title: 'High School Reunion',
    description: 'You attended your high school reunion.',
    type: 'social',
    probability: 0.4,
    minAge: 25,
    maxAge: 50,
    effects: { relationships: 8, happiness: 10 },
    isInteractive: false,
  },
  {
    id: 'pet-adoption',
    title: 'Pet Adoption',
    description: 'You adopted a pet from the shelter.',
    type: 'social',
    probability: 0.2,
    minAge: 20,
    effects: { relationships: 15, happiness: 20, wealth: -1000 },
    isInteractive: false,
  },
  {
    id: 'hobby-discovery',
    title: 'New Hobby',
    description: 'You discovered a new hobby that brings you joy.',
    type: 'random',
    probability: 0.3,
    effects: { happiness: 12, education: 5 },
    isInteractive: false,
  },
  {
    id: 'mentorship',
    title: 'Mentorship Opportunity',
    description: 'Someone asked you to be their mentor.',
    type: 'career',
    probability: 0.25,
    minAge: 30,
    requirements: { career: 50 },
    effects: { career: 8, relationships: 10, happiness: 8 },
    isInteractive: false,
  },
  {
    id: 'volunteer-work',
    title: 'Volunteer Work',
    description: 'You started volunteering for a good cause.',
    type: 'social',
    probability: 0.2,
    minAge: 25,
    effects: { relationships: 12, happiness: 15, wealth: -500 },
    isInteractive: false,
  },
  {
    id: 'life-lesson',
    title: 'Important Life Lesson',
    description: 'You learned an important lesson about life.',
    type: 'random',
    probability: 0.4,
    effects: { education: 8, happiness: 5 },
    isInteractive: false,
  },

  // Debt-Related Events
  {
    id: 'debt-stress',
    title: 'Debt Stress',
    description: 'The weight of your debt is causing severe stress and anxiety.',
    type: 'random',
    probability: 0.3,
    requirements: { debt: 1000 }, // Only triggers if debt > 1000
    effects: { stress: 15, health: -3, happiness: -20 },
    isInteractive: false,
  },
  {
    id: 'debt-collector-call',
    title: 'Debt Collector Call',
    description: 'A debt collector is calling you about your outstanding payments.',
    type: 'random',
    probability: 0.2,
    requirements: { debt: 5000 }, // Only triggers if debt > 5000
    effects: { stress: 25, happiness: -15, health: -2 },
    isInteractive: false,
  },
  {
    id: 'debt-collector-visit',
    title: 'Debt Collector Visit',
    description: 'A debt collector came to your door demanding payment.',
    type: 'random',
    probability: 0.15,
    requirements: { debt: 15000 }, // Only triggers if debt > 15000
    effects: { stress: 30, happiness: -25, health: -4, relationships: -10 },
    isInteractive: false,
  },
  {
    id: 'debt-legal-threat',
    title: 'Legal Action Threat',
    description: 'You received a legal notice threatening court action for your debt.',
    type: 'random',
    probability: 0.1,
    requirements: { debt: 30000 }, // Only triggers if debt > 30000
    effects: { stress: 40, happiness: -30, health: -5, relationships: -15 },
    isInteractive: false,
  },
  {
    id: 'debt-garnishment',
    title: 'Wage Garnishment',
    description: 'Your wages are being garnished to pay off your debt.',
    type: 'random',
    probability: 0.08,
    requirements: { debt: 50000 }, // Only triggers if debt > 50000
    effects: { stress: 35, happiness: -20, wealth: -20, health: -3 },
    isInteractive: false,
  },
  {
    id: 'debt-bankruptcy-consideration',
    title: 'Bankruptcy Consideration',
    description: 'You\'re considering filing for bankruptcy due to overwhelming debt.',
    type: 'random',
    probability: 0.05,
    requirements: { debt: 75000 }, // Only triggers if debt > 75000
    effects: { stress: 50, happiness: -40, health: -6, relationships: -20 },
    isInteractive: true,
    choices: [
      {
        id: 'file-bankruptcy',
        title: 'File for Bankruptcy',
        description: 'Start the bankruptcy process',
        effects: { debt: -50000, stress: 20, happiness: -30, relationships: -25 },
        cost: 2000,
      },
      {
        id: 'keep-struggling',
        title: 'Keep Struggling',
        description: 'Try to pay off debt without bankruptcy',
        effects: { stress: 10, happiness: -10 },
        cost: 0,
      },
    ],
  },

  // New Events - Additional Life Events
  {
    id: 'stray-pet-found',
    title: 'Stray Pet Found',
    description: 'You found a stray dog/cat on the street. It looks hungry and lost.',
    type: 'social',
    probability: 0.15,
    minAge: 20,
    maxAge: 50,
    isInteractive: true,
    icon: '🐕',
    choices: [
      {
        id: 'adopt-stray-pet',
        title: 'Adopt the Pet',
        description: 'Take it home and give it a loving family',
        effects: { happiness: 20, relationships: 15 },
        cost: 100, // Initial adoption costs
      },
      {
        id: 'take-to-shelter',
        title: 'Take to Animal Shelter',
        description: 'Drop it off at the local animal shelter',
        effects: { happiness: 5, relationships: 5 },
        cost: 20, // Transportation costs
      },
      {
        id: 'ignore-stray-pet',
        title: 'Ignore the Pet',
        description: 'Walk away and hope someone else helps',
        effects: { happiness: -5 },
        cost: 0,
      },
    ],
  },

  {
    id: 'startup-offer',
    title: 'Startup Opportunity',
    description: 'Your friend approached you with an exciting startup idea. They want you to be a co-founder!',
    type: 'career',
    probability: 0.12,
    minAge: 25,
    maxAge: 40,
    requirements: { career: 30 },
    isInteractive: true,
    icon: '🚀',
    choices: [
      {
        id: 'join-startup',
        title: 'Join the Startup',
        description: 'Take the risk and become a co-founder',
        effects: { career: 15, wealth: -20, happiness: 10 },
        cost: 10000, // Initial investment
        debtWarning: 'This decision will put you in debt if you cannot afford it. Starting a business is risky but potentially rewarding.',
      },
      {
        id: 'decline-startup',
        title: 'Stay at Current Job',
        description: 'Play it safe and keep your stable job',
        effects: { career: 5, happiness: -5 },
        cost: 0,
      },
    ],
  },

  {
    id: 'startup-success',
    title: 'Startup Success!',
    description: 'Your startup was acquired by Tesla for $100 million! You\'re now a millionaire!',
    type: 'money',
    probability: 0.05,
    minAge: 30,
    maxAge: 50,
    requirements: { career: 80 }, // Only if you joined the startup
    effects: { wealth: 50, happiness: 30, career: 25 },
    isInteractive: false,
    icon: '💰',
  },

  {
    id: 'startup-fraud',
    title: 'Startup Fraud',
    description: 'Your startup turned out to be a front for money laundering! You\'re going to prison for 4 years.',
    type: 'social',
    probability: 0.08,
    minAge: 30,
    maxAge: 50,
    requirements: { career: 70 }, // Only if you joined the startup
    effects: { wealth: -30, happiness: -40, relationships: -20, career: -50 },
    isInteractive: false,
    icon: '⛓️',
  },

  {
    id: 'mother-death',
    title: 'Mother\'s Funeral',
    description: 'Your mother has passed away. You attend the funeral feeling devastated.',
    type: 'social',
    probability: 0.1,
    minAge: 30,
    maxAge: 80,
    isInteractive: true,
    icon: '🕊️',
    choices: [
      {
        id: 'mourn-with-family',
        title: 'Mourn with Family',
        description: 'Spend time with family and loved ones',
        effects: { relationships: 10, happiness: -20, health: -5 },
        cost: 2000, // Funeral and travel costs
      },
      {
        id: 'mourn-alone',
        title: 'Mourn Alone',
        description: 'Grieve privately and process alone',
        effects: { happiness: -30, relationships: -10, health: -10 },
        cost: 500,
      },
    ],
  },

  {
    id: 'spouse-support',
    title: 'Spouse\'s Support',
    description: 'Your spouse has been incredibly supportive during this difficult time. Their love helps you heal.',
    type: 'social',
    probability: 0.3,
    minAge: 25,
    maxAge: 80,
    requirements: { relationships: 60 }, // Only if married
    effects: { relationships: 15, happiness: 20, health: 10 },
    isInteractive: false,
    icon: '💕',
  },

  {
    id: 'lottery-scam',
    title: 'Lottery Scam',
    description: 'You received a call claiming you won a lottery you never entered. They want your bank details.',
    type: 'money',
    probability: 0.08,
    minAge: 18,
    maxAge: 70,
    isInteractive: true,
    icon: '📞',
    choices: [
      {
        id: 'ignore-scam',
        title: 'Ignore the Call',
        description: 'Hang up immediately - it\'s clearly a scam',
        effects: { happiness: 5 }, // Relief from avoiding scam
        cost: 0,
      },
      {
        id: 'fall-for-scam',
        title: 'Provide Bank Details',
        description: 'Give them your information hoping for the money',
        effects: { wealth: -20, happiness: -30, stress: 20 },
        cost: 5000, // Money lost to scam
        debtWarning: 'This is likely a scam and will result in financial loss.',
      },
    ],
  },

  {
    id: 'celebrity-encounter',
    title: 'Celebrity Encounter',
    description: 'You randomly met a famous celebrity at a coffee shop! They were surprisingly friendly.',
    type: 'social',
    probability: 0.05,
    minAge: 20,
    maxAge: 60,
    effects: { happiness: 25, relationships: 10 },
    isInteractive: false,
    icon: '⭐',
  },

  {
    id: 'time-capsule',
    title: 'Time Capsule Found',
    description: 'You discovered a time capsule you buried as a child. The memories bring back nostalgia.',
    type: 'social',
    probability: 0.06,
    minAge: 30,
    maxAge: 50,
    effects: { happiness: 15, relationships: 5 },
    isInteractive: false,
    icon: '📦',
  },

  {
    id: 'neighbor-help',
    title: 'Helpful Neighbor',
    description: 'Your neighbor helped you fix something around the house. You\'ve become good friends.',
    type: 'social',
    probability: 0.2,
    minAge: 25,
    maxAge: 70,
    effects: { relationships: 10, happiness: 8 },
    isInteractive: false,
    icon: '🏠',
  },

  // ZUS Insurance Events
  {
    id: 'accident-zus-covered',
    title: 'Accident - ZUS Covered!',
    description: 'You had an accident! Fortunately, your ZUS insurance covered all medical expenses.',
    type: 'health',
    probability: 0.15,
    minAge: 18,
    maxAge: 70,
    requirements: { isZusRegistered: true },
    effects: { health: -5, happiness: 5 },
    isInteractive: false,
    icon: '🏥',
  },

  {
    id: 'accident-no-zus',
    title: 'Accident - No Insurance!',
    description: 'You had an accident! Now you have to pay $10,000 in medical bills. If you were registered with ZUS insurance, it would have covered all expenses.',
    type: 'health',
    probability: 0.15,
    minAge: 18,
    maxAge: 70,
    requirements: { isZusRegistered: false },
    effects: { health: -10, happiness: -15, wealth: -20 },
    cost: 10000,
    isInteractive: false,
    icon: '💸',
  },

  // Unexpected Expense Events
  {
    id: 'birthday-gift',
    title: 'Friend\'s Birthday Gift',
    description: 'Your friend is having a birthday party. You need to buy a gift.',
    type: 'money',
    probability: 0.1,
    minAge: 18,
    maxAge: 60,
    effects: { relationships: 5, happiness: 3 },
    cost: 50,
    isInteractive: false,
    icon: '🎁',
  },

  {
    id: 'help-grandma',
    title: 'Help Grandma with Shopping',
    description: 'You helped your grandmother with her shopping. She gave you some money as thanks.',
    type: 'money',
    probability: 0.08,
    minAge: 18,
    maxAge: 50,
    effects: { relationships: 8, happiness: 5 },
    cost: -10, // Negative cost means you receive money
    isInteractive: false,
    icon: '👵',
  },

  // Young Adult Support Events (18-26)
  {
    id: 'parent-support',
    title: 'Parental Financial Support',
    description: 'Your parents have decided to help you financially during your studies. They sent you $2,000 to help with expenses.',
    type: 'money',
    probability: 0.3,
    minAge: 18,
    maxAge: 26,
    effects: { relationships: 10, happiness: 15, wealth: 5 },
    cost: -2000, // Receive $2000
    isInteractive: false,
    icon: '👨‍👩‍👧‍👦',
  },

  {
    id: 'graduation-gift',
    title: 'Graduation Gift',
    description: 'Congratulations! You graduated and received money from family and friends as a graduation gift.',
    type: 'money',
    probability: 0.4,
    minAge: 22,
    maxAge: 26,
    requirements: { education: 15 }, // Only if you have some education
    effects: { happiness: 20, relationships: 10, wealth: 10 },
    cost: -1500, // Receive $1500
    isInteractive: false,
    icon: '🎓',
  },


  {
    id: 'scholarship',
    title: 'Scholarship Award',
    description: 'Great news! You received a scholarship that covers part of your education costs.',
    type: 'money',
    probability: 0.15,
    minAge: 18,
    maxAge: 25,
    requirements: { education: 5 }, // Need to be studying
    effects: { happiness: 25, wealth: 20, education: 10 },
    cost: -3000, // Receive $3000
    isInteractive: false,
    icon: '🏆',
  },

  {
    id: 'internship-offer',
    title: 'Internship Opportunity',
    description: 'You got an internship offer! This will provide valuable experience and some income.',
    type: 'career',
    probability: 0.2,
    minAge: 19,
    maxAge: 25,
    requirements: { education: 8 }, // Need some education
    effects: { career: 15, wealth: 8, happiness: 12 },
    cost: -500, // Small income
    isInteractive: false,
    icon: '📚',
  },

  {
    id: 'family-help',
    title: 'Family Emergency Fund',
    description: 'Your family set up an emergency fund for you to help with unexpected expenses.',
    type: 'money',
    probability: 0.2,
    minAge: 18,
    maxAge: 26,
    effects: { relationships: 15, happiness: 10, wealth: 8 },
    cost: -1000, // Receive $1000
    isInteractive: false,
    icon: '💰',
  },

  {
    id: 'financial-struggle-help',
    title: 'Financial Support from Friends',
    description: 'Your friends noticed you\'re struggling financially and decided to help you out.',
    type: 'money',
    probability: 0.15,
    minAge: 18,
    maxAge: 30,
    requirements: { debt: 1000 }, // Only triggers if in debt
    effects: { relationships: 20, happiness: 15, wealth: 10 },
    cost: -1200, // Receive $1200
    isInteractive: false,
    icon: '🤝',
  },

  // Special Birthday Event
  {
    id: 'birthday-16',
    title: '16th Birthday Gift',
    description: 'Happy 16th birthday! Your family and friends gave you $2,000 as a special birthday gift to help you start your adult life.',
    type: 'money',
    probability: 1.0, // Always happens
    minAge: 16,
    maxAge: 16,
    effects: { relationships: 15, happiness: 25, wealth: 20 },
    cost: -2000, // Receive $2000
    isInteractive: false,
    icon: '🎂',
  },

  {
    id: 'side-hustle',
    title: 'Side Hustle Opportunity',
    description: 'You found a side hustle opportunity that could provide extra income. This could help with your expenses.',
    type: 'money',
    probability: 0.25,
    minAge: 18,
    maxAge: 35,
    effects: { wealth: 12, happiness: 8, career: 5 },
    cost: -400, // Monthly extra income
    isInteractive: false,
    icon: '💪',
  },
];
